import React from 'react';

const WebRTCEntryProblem = (props) => (

    <div>WebRTC Entry Problem = {props.errorMessage}</div>
    

);

export default WebRTCEntryProblem